import { Paper } from '@mui/material';
import styled from 'styled-components';
export const Container = styled(Paper) `
  ${({ margin }) => `margin:${margin ? margin : '0'};`}

  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Content = styled.span `
  box-sizing: border-box;

  padding: 1rem 0;
  white-space: nowrap;
`;
